import type { ReactElement } from 'react';
import * as Scaffold from '../scaffold/index.js';
import type { PlaceholderProps } from './types.js';
import { Linker } from '#~/agent/components/linker/index.js';
import * as Monitor from '#~/agent/components/monitoring/index.js';

/** `<Placeholder>` component. */
export const Placeholder = (props: PlaceholderProps): ReactElement => (
  <Scaffold.Placeholder
    header={
      <Scaffold.Header>
        <Monitor.Root className='w-[320px]'>
          <Linker className='p-16 pb-32' />
        </Monitor.Root>
      </Scaffold.Header>
    }
    {...props}
  >
    <div className='grid h-full place-items-center'>
      <Linker className='max-w-[256px]' />
    </div>
  </Scaffold.Placeholder>
);
